/*
  Shared "claimed prize" helper. When a visitor claims a spin-wheel discount,
  the wheel saves it in localStorage. Shopify's storefront cart does not show
  discount codes (they only apply at checkout), so this file lets the buy
  panel and the free-shipping messages show the same price checkout will use.

  The claimed code is an order-level discount that stacks on top of the
  automatic bundle discount (which Shopify applies per item).
*/
(function () {
  var KEY = 'ama_wheel_v1';

  function readPrize() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY));
      if (s && s.prize && s.prize.expires && s.prize.expires < Date.now()) return null;
      return s && s.prize && s.prize.claimed ? s.prize : null;
    } catch (e) {
      return null;
    }
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var Promo = {
    percent: function () {
      var p = readPrize();
      return p && Number(p.percent) > 0 ? Number(p.percent) : 0;
    },
    code: function () {
      var p = readPrize();
      return p && p.code ? p.code : '';
    },
    // Order total in cents after the claimed code. The code is an
    // order-level discount, so it comes off the subtotal after the bundle
    // discount, rounded down to the cent, like Shopify.
    totalAfterCode: function (total) {
      var pct = Promo.percent();
      return pct ? total - Math.floor(total * (pct / 100)) : total;
    },
    notify: function () {
      document.dispatchEvent(new CustomEvent('ama:promo-change'));
      Promo.refreshShipping();
    },
    refreshShipping: function () {
      var C = window.AMA_REWARDS || {};
      document.querySelectorAll('[data-ama-ship]').forEach(function (root) {
        root.setAttribute('data-ama-done', '');
        var lines;
        try { lines = JSON.parse(root.getAttribute('data-lines') || '[]'); } catch (e) { lines = []; }
        if (!lines.length) return;

        var before = 0, paid = 0;
        lines.forEach(function (l) {
          before += l[0] * l[1];
          if (!l[2]) paid += l[1];
        });
        var after = Promo.totalAfterCode(before);
        var min = C.minTins || 0, freeAt = C.freeShipTins || 0;
        var tins = function (n) { return n + (n === 1 ? ' tin' : ' tins'); };

        // Rewards that come after free shipping, in the order they unlock.
        var steps = [];
        if (C.discountAt && C.discountPct) steps.push([C.discountAt, C.discountPct + '% off']);
        if (window.AmaRewards && window.AmaRewards.hasFreeTin()) steps.push([C.freeTinAt, 'a free tin']);
        if (window.AmaRewards && window.AmaRewards.hasGift()) steps.push([C.giftAt, 'a free mystery gift']);
        steps.sort(function (x, y) { return x[0] - y[0]; });
        var next = null;
        for (var i = 0; i < steps.length; i++) { if (steps[i][0] > paid) { next = steps[i]; break; } }

        var text = root.querySelector('[data-ama-ship-text]');
        var fill = root.querySelector('[data-ama-ship-fill]');
        var note = root.querySelector('[data-ama-ship-promo]');
        var target = Math.max(min, freeAt);
        if (text) {
          var done = false, html;
          if (paid < min) {
            html = 'Add <strong>' + (min - paid) + '</strong> more ' + (min - paid === 1 ? 'tin' : 'tins') + ' to check out';
          } else if (freeAt && paid < freeAt) {
            html = 'Add <strong>' + (freeAt - paid) + '</strong> more ' + (freeAt - paid === 1 ? 'tin' : 'tins') + ' for free shipping';
          } else {
            done = true;
            html = "You've unlocked free shipping";
            if (next) { html += ' · ' + tins(next[0] - paid) + ' more for ' + next[1]; target = next[0]; }
          }
          text.className = 'ama-free-shipping__text' + (done ? ' ama-free-shipping__text--done' : '');
          text.innerHTML = html;
        }
        if (fill && target) fill.style.width = Math.min(100, (paid * 100) / target) + '%';
        if (note) {
          var code = Promo.code();
          if (Promo.percent() && before > after) {
            note.textContent = code + ' applied at checkout: you save ' + money(before - after) + ' more. Estimated total ' + money(after);
            note.hidden = false;
          } else {
            note.hidden = true;
          }
        }
      });
    },
  };

  window.AmaPromo = Promo;

  function init() {
    Promo.notify();
    // Cart sections are re-rendered over AJAX; fix up any freshly inserted ones.
    new MutationObserver(function () {
      if (document.querySelector('[data-ama-ship]:not([data-ama-done])')) Promo.refreshShipping();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('storage', function (e) { if (e.key === KEY) Promo.notify(); });
})();
